/**
 * Accordion
 */

export default function initAccordion(){
	const accordions = document.querySelectorAll('.accordion');

	if ( accordions.length>0 ){
		accordions.forEach(accordion => {
			const triggers = accordion.querySelectorAll('.accordion__trigger');

			// Open on click
			triggers.forEach(trigger => {
				trigger.addEventListener('click', function (e){
					accordionToggle(e);
				});
			});

			// Open on pressing enter or space (for accessibility)
			accordion.addEventListener('keydown', function (e){
				if ( e.keyCode===13 || e.keyCode===32 ){
					accordionToggle(e);
				}
			});
		});
	}
}

/* --- Toggle accordion --- */
function accordionToggle(e){
	let currentTrigger = e.target;
	const parentAccordion = currentTrigger.closest('.accordion');
	const isExpanded = currentTrigger.getAttribute('aria-expanded') === 'true';
	const panelId = currentTrigger.getAttribute('aria-controls');
	const currentPanel = document.getElementById(panelId);

	// Collapse all panels
	parentAccordion.querySelectorAll('.accordion__trigger').forEach(trigger => {
		const panel = document.getElementById(trigger.getAttribute('aria-controls'));

		trigger.setAttribute('aria-expanded', 'false');
		if ( panel ){
			panel.setAttribute('hidden', '');
			panel.style.maxHeight = null;
		}
	});

	// Expand this one only if it wasn't already open
	if ( !isExpanded && currentPanel ){
		currentTrigger.setAttribute('aria-expanded', 'true');
		currentPanel.removeAttribute('hidden');
		currentPanel.style.maxHeight = currentPanel.scrollHeight + 'px';
	}
}